<template>
    <div
        v-if="shouldShowHeader"
        class="mt-4 mb-2 flex justify-between"
        :class="{
            'text-red-error': hasErrorState,
        }"
    >
        <span class="text-[16px] font-semibold text-ink">{{label}}</span>

        <span class="text-[16px] text-ink text-right">{{selectedLabel}}</span>
    </div>
    <div class="flex flex-wrap gap-2.5 mb-[32px]">
        <swatch-button
            v-for="option in swatchOptions"
            :key="option.value"

            :input-name="colorsPlacement"

            :input-value="option.value"
            :input-color="option.color"
            :input-color-secondary="option.colorSecondary"

            :selected="option.selected"

            :variant="'small'"

            :label="option.label"

            :no-thanks="option.placeholder"

            @valueChange="selectColor(option)"

            class="flex-shrink-0 flex-grow-0"
        />
    </div>
</template>

<script>
    import SwatchButton from './buttons/SwatchButton.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            SwatchButton,
        },

        emits: ['color-selected'],

        props: {
            placement: Object,
            colorsPlacement: String,
            filterBy: String,
            title: String,
            colors: {
                type: Array,
                required: false,
                default: null,
            },
            shouldShowHeader: {
                type: Boolean,
                default: true,
            },

            hasErrorState: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            panelToReset() {
                return this.customizerStore.panelToReset;
            },

            usePlacement() {
                return this.viewController.findPlacement(this.colorsPlacement);
            },

            label() {
                return this.title ?? this.usePlacement.name;
            },

            selectedLabel() {
                return this.swatchOptions.find((x) => x.selected)?.label;
            },

            selectedValue() {
                const component = this.viewController.selectedAtPlacement(this.colorsPlacement);
                return component?.code;
            },

            isToeEngraving() {
                return this.placement.name.includes('Toe Engraving');
            },

            isCharacterStamping() {
                return this.placement.code.includes('StampingStyle');
            },

            swatchOptions() {
                if (this.colors) {
                    return this.colors.map((option) => {
                        const order = option.custom && option.custom['v-rank'] ? +option.custom['v-rank'] : 0;

                        return {
                            label: option.name,
                            value: option.code,
                            selected: option.code === this.selectedValue,
                            color: option.hex,
                            colorSecondary: option.custom?.['v-hex-inner'],
                            order,
                            placeholder: false,
                        };
                    }).sort((a, b) => a.order - b.order);
                }

                // Original behavior when colors aren't passed
                const options = this.usePlacement?.components ?? [];
                return options.filter((option) => {
                    if (option.placeholder) {
                        return false;
                    }
                    return true;
                }).map((option) => {
                    let order = option.custom && option.custom['v-rank'] ? +option.custom['v-rank'] : 0;

                    // Put No Thanks buttons at the end.
                    if (option.placeholder) {
                        order = 10000;
                    } else {
                        order = +option.custom['v-rank'];
                    }

                    const label = this.viewController.componentNames(option).join(' ');

                    return {
                        label,
                        value: option.code,
                        selected: option.code === this.selectedValue,
                        color: option.custom?.['v-hex'],
                        colorSecondary: option.custom?.['v-hex-inner'],
                        order,
                        placeholder: false,
                    };
                }).sort((a, b) => a.order - b.order);
            },
        },

        unmounted() {
            // if (this.isToeEngraving) {
            //     this.selectDefaultColor();
            // }

            // if (this.isCharacterStamping) {
            //     this.selectFirstColor();
            // }
        },

        methods: {
            selectColor(c) {
                this.viewController.updateComponent(this.colorsPlacement, c.value);
                this.$emit('color-selected', this.colorsPlacement);
            },

            selectDefaultColor() {
                const defaultColor = this.swatchOptions.find((x) => x.value === 'StampColor-StampingColor-64');

                if (defaultColor) {
                    this.selectColor(defaultColor);
                }
            },

            selectFirstColor() {
                const firstColor = this.swatchOptions.find((x) => !x.placeholder);

                if (firstColor) {
                    this.selectColor(firstColor);
                }
            },

            resetPanel(panel) {
                if (this.isToeEngraving && panel === 'Toe Engraving') {
                    this.selectDefaultColor();
                }

                if (this.isCharacterStamping && panel === 'Character Stamping') {
                    this.selectFirstColor();
                }
            },
        },
    };
</script>
